import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import Styles from "./SectionHeader.module.css";

/**
 * Shared section header for the `numbered`, `features` and `pills` variations.
 *
 * `heading` is a single `heading2` StructuredText field, so `PrismicRichText`
 * emits its own <h2> — it is never wrapped in one here. The accent run is a
 * "accent" label applied by the editor, which the default serializer renders as
 * <span class="accent">; `.heading :global(.accent)` colours it.
 *
 * NOTE: this renders inside a themed `.wrapper`, so it inherits `--text`,
 * `--text-muted` and `--accent` from that root. It is never mounted standalone.
 */
const SectionHeader = ({ eyebrow, heading, intro }) => {
	return (
		<header className={Styles.header}>
			{eyebrow && <p className={Styles.eyebrow}>{eyebrow}</p>}
			{isFilled.richText(heading) && (
				<div className={Styles.heading}>
					<PrismicRichText field={heading} />
				</div>
			)}
			{isFilled.richText(intro) && (
				<div className={Styles.intro}>
					<PrismicRichText field={intro} />
				</div>
			)}
		</header>
	);
};

export default SectionHeader;
